module.exports = __webpack_public_path__ + "img/governance.5c6342cb.svg";